import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Hipobuy Spreadsheet', href: '#hipobuy-spreadsheet' },
    { label: 'Categories', href: '#categories' },
    { label: 'Comparisons', href: '#comparison' },
    { label: 'Safety', href: '#safety' },
  ];

  const handleCategoryClick = (url: string) => {
    setMobileOpen(false);
    setMobileCategoriesOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-600 transition-colors duration-200"
          >
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-file-list-3-line text-background-50 text-sm"></i>
            </div>
            <span className="font-heading font-semibold text-base md:text-lg whitespace-nowrap">
              Hipobuy Spreadsheet Guide
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#categories"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Categories
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2.5 px-2 rounded-md hover:bg-background-100 transition-colors"
              >
                {link.label}
              </a>
            ))}

            <div className="border-t border-background-200 my-2"></div>

            <button
              onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
              className="flex items-center justify-between w-full text-sm font-semibold text-foreground-800 py-2.5 px-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line text-primary-500"></i>
                All Product Categories
              </span>
              <i className={`${mobileCategoriesOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-400 transition-transform duration-200`}></i>
            </button>

            {mobileCategoriesOpen && (
              <div className="flex flex-col gap-0.5 pl-2 mt-1 border-l-2 border-primary-200 ml-3">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleCategoryClick(cat.url)}
                    className="flex items-center gap-2.5 text-xs text-foreground-600 hover:text-primary-600 hover:bg-background-100 py-2 px-3 rounded-md transition-colors text-left cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-6 h-6 flex items-center justify-center rounded bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </button>
                ))}
              </div>
            )}

            <div className="border-t border-background-200 my-2"></div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 px-2 py-2.5 text-sm font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer justify-center"
            >
              <i className="ri-external-link-line"></i>
              Visit Hipobuy Sheet
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}